export const ENUM = {
	PLAT_LIST: [
		{
			value: 0,
			label: '全部'
		}, {
			value: 1,
			label: '淘宝'
		}, {
			value: 3,
			label: '京东'
		}, {
			value: 4,
			label: '拼多多'
		}, {
			value: 25,
			label: '抖音'
		}, {
			value: 9,
			label: '唯品会'
		}, {
			value: 22,
			label: '快手'
		}, {
			value: 12,
			label: '苏宁'
		}, {
			value: 35,
			label: '中免日上'
		}, {
			value: 16,
			label: '美团'
		}, {
			value: 13,
			label: '淘宝闪购'
		}, {
			value: 21,
			label: '滴滴'
		}, {
			value: 14,
			label: '飞猪'
		}, {
			value: 33,
			label: '淘宝直播'
		}, {
			value: 24,
			label: '点餐'
		}
	],
	STATUS_LIST: [
		{
			label: '全部',
			value: 0
		},
		{
			label: '已付款',
			value: 2
		},
		{
			label: '已收货',
			value: 4
		},
		{
			label: '已失效',
			value: 3
		},
		{
			label: '已结算',
			value: 1
		}
	],
	HEADER_TAB: [
		{
			label: '我的订单',
			value: 1
		},
		{
			label: '团队订单',
			value: 2
		},
	],
}